module.exports = __webpack_public_path__ + "static/img/Tobie-Travaglia.8cff114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tobie-Travaglia.jpg
// module id = sPZx
// module chunks = 0